export default {
      id: "arrow-sm-top-usage",
      viewBox: "0 0 10 8",
      url: __webpack_public_path__ + "sprite.svg#arrow-sm-top-usage",
      toString: function () {
        return this.url;
      }
    }